import { EventConfig } from '@/types/event.types';
import { DemoConfig } from '@/types/demo.types';

/**
 * Static Event Config Service for Demo Mode
 * Loads event configuration from /public/demo-config.json
 * instead of fetching from backend API
 */
export class StaticEventConfigService {
  /**
   * Get event configuration from static JSON file
   * @param _eventSlug - Event slug (unused in demo mode)
   * @returns Event configuration
   */
  async getConfig(_eventSlug: string = 'demo'): Promise<EventConfig> {
    try {
      const response = await fetch('/demo-config.json');

      if (!response.ok) {
        throw new Error(`Failed to load demo config: ${response.statusText}`);
      }

      const data: DemoConfig = await response.json();

      // Transform demo config to EventConfig format
      return {
        event: data.event,
        course: data.course,
        cameraPresets: data.cameraPresets,
      };
    } catch (error) {
      console.error('[StaticEventConfigService] Error loading demo config:', error);
      throw error;
    }
  }
}
